import { useErrorToast } from '../toastHooks';

export const useDownloadPermittedFile = () => {
  const { onShowErrorToast } = useErrorToast();
  const onDownloadPermittedFile = async (url: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const fileUrl = URL.createObjectURL(blob);
      const urlObj = new URL(url);

      const rawDisposition = urlObj.searchParams.get(
        'response-content-disposition',
      );

      let cleanFileName: string;

      if (rawDisposition) {
        const decoded = decodeURIComponent(rawDisposition);
        const [, baseName = 'file'] =
          decoded.match(/filename="?([^";]+)"?/) ?? [];

        const lastSegment = urlObj.pathname.split('/').pop() || '';
        const extMap: Record<string, string> = { podcast: 'mp3' };
        const ext = extMap[lastSegment] ?? lastSegment;

        cleanFileName = `${baseName}.${ext}`;
      } else {
        cleanFileName = (urlObj.pathname.split('/').pop() || 'file').split(
          '?',
        )[0];
      }

      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = cleanFileName;
      link.click();
    } catch (err) {
      onShowErrorToast();
    }
  };

  return { onDownloadPermittedFile };
};
